// extracted by mini-css-extract-plugin
export var adjacentSlide = "_pq-9";
export var arrowButtonContainer = "_pq-5";
export var arrowButtonIcon = "_pq-6";
export var carouselArrowButton = "_pq-2";
export var carouselElementContainer = "_pq-1";
export var currentSlide = "_pq-8";
export var left = "_pq-3";
export var otherSlide = "_pq-a";
export var productCarouselContainer = "_pq-0";
export var right = "_pq-4";
export var sliderOverflow = "_pq-7";